export function method(__fn__) {
    // Explain that this is done in build-time
    return {
        __fn__,
    };
}
function joinUrls(baseUrl, relativeUrl) {
    return baseUrl.replace(/\/+$/, '') + '/' + relativeUrl.replace(/^\/+/, '');
}
const baseUrl = typeof window !== 'undefined' &&
    window.location.hostname === 'static.parastorage.com'
    ? `https://www.wix.com`
    : '';
export function dsl({ fileName, functionName, }) {
    /**
     * This entire file is compiled in one of 2 options:
     * 1. During the user build - the file is being processed by webpack,
     *    process.env vars are being replaced and the result is bundled into
     *    the user bundle which imports serverless api methods.
     *    This option applies to start/build commands and storybook start/build commands.
     * 2. During test running (local e2e, not sled) - the file is being processed
     *    by a jest transform, and process.env vars are not being touched.
     *    Therefore NODE_ENV = 'test' and YOSHI_SERVERLESS_BASE is undefined.
     *
     * When running tests, we need to reach the local server that was created
     * by the serverless testkit, therfore base has to be empty for the final
     * url to be correct.
     *
     */
    const base = process.env.NODE_ENV === 'test' ? '' : process.env.YOSHI_SERVERLESS_BASE;
    return (...args) => {
        return {
            url: joinUrls(`${baseUrl}${base}`, `/_api_/${fileName}`),
            method: 'POST',
            data: {
                fileName,
                functionName,
                args,
            },
            _pickResponseBody: '.payload',
            _logs: '.logs',
        };
    };
}
//# sourceMappingURL=wrap.js.map